import {Spin} from 'antd'
import styles from './Loading.module.scss'
import {SpinSize} from 'antd/es/spin'

const Loading = ({size}: {size?: SpinSize}) => {
  return (
    <div className={styles.loadingWrapper}>
      <Spin size={size ? size : 'large'} />
    </div>
  )
}

export default Loading
